module.exports = __webpack_public_path__ + "img/waterpurifier09.dc455091.jpg";